import { ParticipatingCountries } from '../interfaces/participating-countries.interface';
import { Categories } from '../../products/interfaces/categories.interface';
import { Product } from '../../products/interfaces/product.interface';
import { PurchaseFlow } from '../enums/purchase-flow.enum';
import { EventEmitter, Injectable, OnInit } from '@angular/core';
import { CacheService } from '../../shared/services/cache.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { MemberType } from '../enums/member-type.enum';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { Router } from '@angular/router';
import { PortalCountry } from '../interfaces/portal-country.interface';
import { Member } from '../interfaces/member.interface';
import { MemberLevel } from '../enums/member-level.enum';
import { environment } from '../../../environments/environment';
import { OrderRulesResponse } from '../../shared/interfaces/order-rules-response.interface';
import { Cart } from '../models/cart.model';
import { StoreConfig } from '../interfaces/store-config.interface';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { MenuItem } from '../interfaces/menu-item.interface';
import * as $ from 'jquery';
import { MemberAcknowledgementRequest } from '../interfaces/member-acknowledgement-request.interface';
import { ActionItemResponse } from '../interfaces/action-item.interface';
import { DocumentCategoryType, Portal, DisplaySectionId } from '../enums/document-type.enum';
import { MemberAllowedResources } from '../interfaces/member-allowed-resources.interface';
import { MemberResourcesConstants } from '../constants/member-resources.constants';
import { MemberAllowedResourcesLookup } from '../enums/member-allowed-resources.enum';
import { MemberPrivilege } from '../interfaces/member-privilege.interface';
import { ActiveSessionService } from './active-session.service';
import { TranslateParam } from '../../common/interfaces';
import { SponsorSearchResponse } from '../interfaces/sponsor-search-response.interface';
import { SponsorSearchRequest } from '../interfaces/sponsor-search-request.interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap, map, mergeMap } from 'rxjs/internal/operators';
import { MemberAllowedCountries } from '../interfaces/member-allowed-countries.interface';
import { DiscountPercentageResponse } from '../interfaces/discount-percentage.response.interface';
import { MapLocationInfo } from '../interfaces/map-location-info.interface';
import { AppCountryConfig } from 'src/app/app-country-config.interface';
import { AppConfigService } from 'src/app/app-config.service';
import { SharedConstants } from '../constants/shared.constants';
import { AuthService } from './auth.service';
import { HamburgerItemConstants } from '../constants';
import { Country } from '../interfaces/country.interface';
import { MemberVatAndDiscountInfo } from '../interfaces/member-vat-discount.interface';
import { ReportOnlyCountryService } from './report-only-country.service';
import { MemberDisplayConfigInfo } from '../interfaces/member-display-config-info.interface';
import { MemberSalePromotionModel } from '../interfaces/member-sale-promotion.interface';
import { CountryPhoneNumberFormats } from '../constants/country-phonenumber-format.constant';
import { CountryMetaData } from '../interfaces/CountryMetaData.interface';
import { Language } from '../interfaces/language.interface';
import { NonNullAssert } from '@angular/compiler';

@Injectable()
export class CommonService implements OnInit {
  private widgetConfigUrl: string = environment.uiTemplateBaseUrl +
    '/test/productwidget.json?templateVersion=' + environment.templateVersion;
  private _headerurl: string = environment.uiTemplateBaseUrl +
    '/test/countries-languages.json?templateVersion=' + environment.templateVersion;
  private cmsWidgetConfigUrl: string = environment.uiTemplateBaseUrl +
    '/test/widgetconfig.json';
  private _productGroupUrl: string = environment.cdnURL +
    '/flpi/catalog-json/product-groups.json?templateVersion=' + environment.templateVersion;

  private _accountServiceUrl: string = environment.apiUrl + '/account/V1/';

  // Collection of EventEmitter object;
  private _eventEmitters: { [id: string]: EventEmitter<any> } = {};

  isoCountryCode: string;
  orderRules: OrderRulesResponse;
  thresholdCrossed = false;
  shoppingCart: Cart;
  store: StoreConfig;
  appConfig: AppCountryConfig;
  languageCode: string;

  constructor(
    private _http: HttpClient,
    private _cacheService: CacheService,
    private _configurationService: ConfigurationService,
    private _activeSessionService: ActiveSessionService,
    private _appConfigService: AppConfigService,
    // private _reportOnlyCountryService: ReportOnlyCountryService,
    private _authService: AuthService
  ) {
    this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode).toUpperCase();
    this.appConfig = this._appConfigService.getSettings(this.isoCountryCode);
    this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
  }

  ngOnInit() {
  }

  /**
   * Create a singleton EventEmitter Object
   *  for a given Id
   * @param Id {String}
   * @returns eventEmitter {EventEmitter}
   * */
  getEmitter(id: string): EventEmitter<any> {
    if (this._eventEmitters[id] === undefined) {
      this._eventEmitters[id] = new EventEmitter();
    }
    return this._eventEmitters[id];
  }

  getProductGroupConfig(): Observable<any[]> {
    return this._http
      .get<any[]>(this._productGroupUrl)
      .pipe(catchError(this.handleErrorObservable));
  }


  /**scroll element to specified offset height with duration */
  scrollTo(elementId: string, duration: number): void {
    const element = $('#' + elementId);
    const headerElement = $('#global-banner');

    if (element[0]) {
      let hasFixedTop = false;
      let headerHeight = 0;
      if (headerElement) {
        hasFixedTop = headerElement.hasClass('fixed-top');
        headerHeight = hasFixedTop ? headerElement.height() : 120;
      }
      $('html, body').animate({
        scrollTop: element.offset().top - headerHeight
      }, duration);
    }
  }
 
  getPhoneNumberFormatByCountryCode(countryCode: string): string {
    if (CountryPhoneNumberFormats.formats.find(item => item.countryCode === countryCode)) {
      return CountryPhoneNumberFormats.formats.
        find(item => item.countryCode === countryCode).phoneNumberMaskFormat;
    } else {
      return '(000) 000-0000';
    }
  }
  scrollToPromotionalContent(elementId: string, duration: number): void {
    const element = $('#' + elementId);
    const headerElement = $('#promotion-banner');
    if (element[0]) {
      let hasFixedTop = false;
      let headerHeight = 0;
      if (headerElement) {
        hasFixedTop = headerElement.hasClass('fixed-top');
        headerHeight = hasFixedTop ? headerElement.height() : 120;
      }
      $('html, body').animate({
        scrollTop: element.offset().top - headerHeight
      }, duration);
    }
  }

  /**
   * Scroll a body to a particular distance
   * @param  {number} x
   * @param  {number} y
   * @param  {number} duration
   * @returns void
   */
  scrollByValue(x: number, y: number, duration: number): void {
    $('html, body').animate({
      scrollLeft: x,
      scrollTop: y
    }, duration);
  }

  /**
   * @returns number
   */
  totalSavingsCalc(product: Product, memberTitleId: MemberLevel, wholesaleQualified: boolean, optin: boolean): number {
    const discountPercenatge: number = this.getDiscountPerc();
    let totalSavings: number = ((discountPercenatge * Number(product.retailPrice.toFixed(2))) / 100);
    if (memberTitleId !== MemberLevel.PREFERREDCUSTOMER) {
      totalSavings = (product.retailPrice - product.wholesalePrice) + totalSavings;
    }
    return totalSavings;
  }

  /**
   * @description discount percentage based on UserTitleType
   * @param {number} memberTitleId
   * @param {boolean} wholesaleQualified
   * @returns {number}
   * @memberof CommonService
   */
  getDiscountPerc(): number {
    let discountPercenatge = 0;
    const memberDiscountDetails: DiscountPercentageResponse = this._cacheService.get(CacheKey.MemberDiscountPercentage);
    if (memberDiscountDetails && memberDiscountDetails.discountPercentage) {
      discountPercenatge = memberDiscountDetails.discountPercentage;
    }
    return discountPercenatge;
  }

  /**
   * get user types from member titles table
   * @returns Observable
   */
  getUserTypes(): Observable<any> {
    return this._http
      .get<any>(ApiUrlConstants.configurationApiUrl + 'stores/memberTitles')
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
   * @description get purchase flow type
   * @returns {*}
   * @memberof CommonService
   */
  getPurchaseFlowType(): PurchaseFlow {
    const userInfo = this._cacheService.get(CacheKey.UserInfo);
    if (userInfo && (userInfo.memberTypeId === MemberType.DISTRIBUTOR
      || (userInfo.memberTypeId === MemberType.PREFERREDCUSTOMER && userInfo.wholesaleQualified))) {
      return PurchaseFlow.PERSONAL;
    } else if (userInfo && (userInfo.memberTypeId === MemberType.PREFERREDCUSTOMER && !userInfo.wholesaleQualified)) {
      return this.appConfig.fpc5PercentEnabled ? PurchaseFlow.FPC5PERCENT : PurchaseFlow.PERSONAL;
    } else {
      return PurchaseFlow.RETAIL;
    }
  }


  getCardsContentBySitemapId(sitemapId: number): Observable<any[]> {
    const store: StoreConfig = this._configurationService.getStoreData();
    return this._http
      .get<any[]>(ApiUrlConstants.cmsApiURL + '/portals/' + environment.portalId + '/countries/'
        + store.homeIsocodeThree.toLowerCase() + '/languages/' + this.languageCode + '/dynamic/' + sitemapId)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
   * To get all product caterories from the service
   * @param  {number} groupId
   * @returns Observable
   * With RxJS EMPTY, success callback will not get trigger. It will trigger complete only
   */
  getCategories(storeId: number, groupId: number, languageCode: string): Observable<Categories[]> {
    const memberTitleId = this._activeSessionService.getMemberTitleIdForProducts();
    const userInfo: Member = this._cacheService.get(CacheKey.UserInfo);
    const storeConfig: StoreConfig = this._configurationService.getStoreData();
    const purchaseFlowType = this.getPurchaseFlowType();
    const wholesaleQualified: boolean = userInfo ? userInfo.transactionalWholesaleQualified : false;
    const _cateroriesUrl: string = ApiUrlConstants.productApiUrl + '/v1/stores/' + storeId +
      '/category-groups/' + groupId + '?languageCode=' + this.languageCode + '&memberTitleId=' + memberTitleId +
      '&purchaseFlowType=' + purchaseFlowType + '&countryCode=' + this.isoCountryCode + '&wholesaleQualified=' + wholesaleQualified
      + '&optin=' + (userInfo ? userInfo.transactionalOptin : false)
      + '&taxInclusive=' + storeConfig.taxInclusive;
    return this._http
      .get<Categories[]>(_cateroriesUrl)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
   * To get recent products
   * @param  {number} storeId
   * @returns Observable
   */
  getProductsByIds(browsedProducts: number[], languageCode: string, storeId: number): Observable<Product[]> {
    const storeConfig: StoreConfig = this._configurationService.getStoreData();
    const userInfo: Member = this._cacheService.get(CacheKey.UserInfo);
    const memberTitleId = this._activeSessionService.getMemberTitleIdForProducts();
    const purchaseFlowType = this.getPurchaseFlowType();
    const wholesaleQualified: boolean = userInfo ? userInfo.transactionalWholesaleQualified : false;
    let _productsUrl = ApiUrlConstants.productApiUrl + '/v1/stores/products/recentlyviewed?storeId=' + storeId +
      '&productIds=' + browsedProducts.join(',') + '&languageCode=' + this.languageCode +
      '&memberTitleId=' + memberTitleId + '&purchaseFlowType=' + purchaseFlowType + '&countryCode=' +
      this.isoCountryCode + '&wholesaleQualified=' + wholesaleQualified
      + '&optin=' + (userInfo ? userInfo.transactionalOptin : false)
      + '&taxInclusive=' + storeConfig.taxInclusive;
    const priceTierId = this.getMemberSalePromotionPriceTierId();
    if (priceTierId) {
      _productsUrl += '&priceTierId=' + priceTierId;
    }
    return (
      this._http
        .get<Product[]>(decodeURIComponent(encodeURIComponent(_productsUrl)))
        .pipe(catchError(this.handleErrorObservable)));
  }

  /**
   * @returns boolean
   */
  getWholesaleQualified(): boolean {
    const userInfo: Member = this._cacheService.get(CacheKey.UserInfo);
    return userInfo && userInfo.wholesaleQualified ? userInfo.wholesaleQualified : false;
  }


  /**
  * @returns Observable
  */
  getApplicationSites(portalId: number, storeId: number, countryId: number,
    languageCode: string, memberTypeId: number): Observable<MenuItem[]> {
    try {
      languageCode = JSON.parse(languageCode);
    } catch (e) {
      languageCode = languageCode;
    }
    const appMenusUrl = ApiUrlConstants.configurationApiUrl + 'portals/' + portalId +
      '/Stores/' + storeId + '/' + countryId + '/' + languageCode + '?memberTypeId=' + memberTypeId;
    // let _menusUrl: string = environment.uiTemplateBaseUrl + '/test/' + siteName + '-menu-items.json';
    return this._http.get<MenuItem[]>(appMenusUrl)
      .pipe(catchError(this.handleErrorObservable));
  }
  /**
     * get the Application Second level Menus
     * @returns {Observable<any[]>}
     * @memberof CommonService
     */
  getApplicationMenus(): Observable<any[]> {
    // const localMenuURL = environment.uiTemplateBaseUrl + '/test/second-level-menu.json';
    const localMenuURL =environment.cdnURL+'/flpi/catalog-json/second-level-menu.json';
    return this._http.get(localMenuURL)
      .pipe(mergeMap((res: Response) => {
        return this.validateMenus(res);
      }), catchError(this.handleErrorObservable));
  }


  async validateMenus(menus: any): Promise<any> {
    let filteredMenus = new Array<any>();
    let authService = this._authService;
    return new Promise(async function (resolve, reject) {
      if (menus !== null && menus !== undefined
        && menus.length > 0) {
        for (const menu of menus) {
          let privileges: string[] = new Array<string>();
          privileges.push(menu.featureName);
          await authService.hasPrivilege(privileges).then(res => {
            if (res) {
              filteredMenus.push(menu);
            }
          });
        }
      }
      resolve(filteredMenus);
    });
  }



  /**
     * Performs any type of http request.
     * @param url
     * @param options
     * @returns {Observable<Response>}
     */
  getPortalCountries(): Observable<PortalCountry[]> {
    const url: string = ApiUrlConstants.configurationApiUrl + 'portals/' + environment.portalId + '/countries';
    if (environment.betaPortal === false && this.getBetaCountries().length !== 0) {
      return this._http
        .get<PortalCountry[]>(url)
        .pipe(map(res => {
          res = this.updateTitanPlatformFlagsForBetaCountries(res);
          return res;
        }),
          catchError(this.handleErrorObservable));
    }
    else {
      return this._http
        .get<PortalCountry[]>(url)
        .pipe(catchError(this.handleErrorObservable));
    }
  }

  private updateTitanPlatformFlagsForBetaCountries(regions: Array<PortalCountry>) {
    let processedregions: Array<PortalCountry> = [];
    let betaEnabledCountries: Array<string> = this.getBetaCountries();
    if (regions !== null && regions !== undefined && regions.length > 0) {
      for (let region of regions) {
        if (region.countries !== null && region.countries !== undefined && region.countries.length > 0) {
          for (let country of region.countries) {
            if (betaEnabledCountries.includes(country.isocodeThree.toLowerCase())) {
              country.titanPlatformEnabled = false;
            }
          }
        }
      }
    }
    return regions;
  }

  getBetaCountries(): string[] {
    let betaCountries: Array<string> = [];
    if (environment.betaEnabledCountries !== undefined && environment.betaEnabledCountries !== null
      && environment.betaEnabledCountries !== '') {
      betaCountries = environment.betaEnabledCountries.toLowerCase().split(',');
    }
    return betaCountries;
  }


  /**
   * for qa demo we are doing this changes later we will remove
   * @param  {string} isoTwoCode
   * @returns string
   */
  getISOThreeLetterCountryCode(isoThreeCode: string): string {
    return isoThreeCode;
  }


  /**
   * @description To avoid screen flicker, while opening modal popup.
   * @param {boolean} onShow
   * @memberof CommonService
   */
  jumpingScroll(onShow: boolean): void {
    const body = document.body;
    if (body) {
      const offset = (window.innerWidth - body.clientWidth);
      if (onShow) {
        $('#global-banner').css({ 'left': -offset + 'px' });
        // body.style.paddingRight = offset + 'px';
      } else {
        $('#global-banner').css({ 'left': '0px' });
        // body.style.paddingRight = '0px';
      }
    }
  }
  navigateToLegacy(countryCode: string) {
    const body = { 'countryCode': countryCode, 'portal': 'Account' };
    return this._http.post(this._accountServiceUrl + 'sso/legacy/login', body)
      .map((response: any) => response)
      .catch(this.handleErrorObservable);
  }

  getLanguageCode(): string {
    let languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    if (languageCode === undefined || languageCode === null || languageCode === '') {
      const storeConfig: StoreConfig = this._cacheService.get(CacheKey.StoreConfiguration);
      if (storeConfig !== undefined && storeConfig !== null &&
        storeConfig.languages !== undefined && storeConfig.languages !== null) {
        const languages: any[] = storeConfig.languages;
        languageCode = languages.find((x: any) => x.default === true) || languages[0];
      }
    }
    return languageCode;
  }

  /**
  * Get Configuration based on sitemapNode
  *
  * @returns {Observable <any>}
  */
  getCMSWidgetConfiguration(): Observable<any[]> {
    return this._http.get(this.cmsWidgetConfigUrl).map((res: any) => res.json());
  }

  /**
  * Checks whether mobile device or not
   * @returns Boolean
   */
  isMobileDevice(): boolean {
    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }

  /**
  * To get the cms data
  * @param  {string} sitemapId
  * @param  {string} country
  * @param  {string} languageId
  * @returns Observable
  */
  getCMSContentBySiteMapId(menuId: number, countryCode: string, storeId: number, portalId: number): Observable<any> {
    const store: StoreConfig = this._configurationService.getStoreData();
    return this._http
      .get(ApiUrlConstants.cmsApiURL + '/portals/' + portalId + '/countries/'
        + store.homeIsocodeThree.toLowerCase() + '/languages/' + this.languageCode + '/' + menuId)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
  * @description This method used for clearing keyclock cahce after logout
  * clearKeyCloakCache
  * @param {string} distributorId
  * @returns
  * @memberof CommonService
  */
  clearKeyCloakCache(distributorId: string): Observable<any[]> {
    const keyclockCacheUrl = environment.ssoApiUserURL + '/'
      + distributorId + '/clear-cache';
    return this._http.get<any[]>(keyclockCacheUrl)
      .pipe(catchError(this.handleErrorObservable));
  }


  /**
  * focus target element
  * @param {HTMLElement} targetElement
  * @returns void
  */
  focusTargetElement(targetElement: string): void {
    const targetEl = document.getElementById(targetElement);
    if (targetEl) {
      targetEl.focus();
    }
  }

  /**
   * To handle the obervable error response
   * @param  {Response|any} error
   */
  private handleErrorObservable(error: Response | any) {
    return Observable.throw(error.message || error);
  }

  /**
   * @description get Member Action Items
   * @date 2018-10-05
   * @param {*} countryCode
   * @param {*} memberType
   * @param {number} memberId
   * @returns {Observable<any>}
   * @memberof CommonService
   */
  getMemberActionItems(countryCode: string, memberId: number, languageCode: string,
    isAcknowledgementReq?: boolean): Observable<ActionItemResponse> {
    let getDocumentsURL = '';
    if (isAcknowledgementReq) {
      getDocumentsURL = ApiUrlConstants.accountApiUrl + '/documents?isAcknowledgementReq=' + isAcknowledgementReq + '&isActionItem=' + true
        + '&countryCode=' + countryCode + '&memberId=' + memberId + '&displaySectionId='
        + DisplaySectionId.MyAction_Center + '&preferredLangCode=' + languageCode + '&portal=' + Portal.Account;
    } else {
      getDocumentsURL = ApiUrlConstants.accountApiUrl + '/documents?isActionItem=' + true
        + '&countryCode=' + countryCode + '&memberId=' + memberId + '&displaySectionId='
        + DisplaySectionId.MyAction_Center + '&preferredLangCode=' + languageCode + '&portal=' + Portal.Account;
    }
    return this._http
      .get<ActionItemResponse>(getDocumentsURL)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
    * Customer Acknowledgement
    * @param customerAckModel
    */
  customerAknowledgement(customerAckModel: MemberAcknowledgementRequest) {
    return this._http.post(ApiUrlConstants.accountApiUrl + '/members/' + customerAckModel.memberId + '/acknowledgement', customerAckModel)
      .pipe(catchError(this.handleErrorObservable));

  }

  /**
   * get Admin Token
   */
  getAdminToken() {
    return this._http.get(ApiUrlConstants.accountApiUrl + '/impersonate')
      .pipe(catchError(this.handleErrorObservable));
  }

  saveUserActionsOnActionCenter(request: any, adminToken: any, userName: string) {
    const documentRequest = {
      'documentState':
        request
    };
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + adminToken);
    return this._http
      .post(environment.ssoApiUserURL + '/' + userName + '/state/' +
        (this._cacheService.get(CacheKey.session_state)), documentRequest,
        { headers: new HttpHeaders().set('Authorization', 'Bearer ' + adminToken) })
      .pipe(catchError(this.handleErrorObservable));

  }
  /**
   * To get portal url from portal name
   * @param {string} portalName
   * @returns {string}
   * @memberof CommonService
   */
  getParentUrl(portalName: string): string {
    let url = '';
    switch (portalName) {
      case 'Shop':
        url = environment.shopURL;
        break;
      case 'Account':
        url = environment.accountSiteURL;
        break;
      case 'Reports':
        url = environment.reportsURL;
        break;
      case 'Corporate':
        url = environment.corporateUrl;
        break;
      case 'Join':
        url = environment.enrollSiteURL;
        break;
    }
    return url;
  }

  downloadFile(documentURL: string): Observable<any> {
    return this._http.get(documentURL, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), responseType: 'blob'
    }).pipe(
      tap(data => console.log('You received data'),
        error => console.log(error)
      ));
  }

  /**
   * Get Member allowed Resources based on MemberType
   * @param memberType
   */
  getMemberAllowedResources(memberType: string): Observable<MemberPrivilege[]> {
      return this._http.get(ApiUrlConstants.accountApiUrl + '/member-types/' + memberType + '/privileges')
      .pipe(mergeMap((res: Response) => {
        return this.validateMemberAllowedResources(res);
      }), catchError(this.handleErrorObservable));
  }

  async validateMemberAllowedResources(memberPrivileges: any): Promise<any> {
    let filteredPrivileges: MemberPrivilege[] = new Array<MemberPrivilege>();
    let authService = this._authService;
    return new Promise(async function (resolve, reject) {
      if (memberPrivileges !== null && memberPrivileges !== undefined
        && memberPrivileges.length > 0) {
          for(const prv of memberPrivileges){
            let privileges: string[] = new Array<string>();
            privileges.push(prv.resource.replace(/ /g,""));
            await authService.hasPrivilege(privileges).then(res => {
              if (res) {
                filteredPrivileges.push(prv);
              }
            });
          }
      }
      resolve(filteredPrivileges);
    });
  }

  /**
  * to get all the countries
  */
  getCountries() {
    return this._http
      .get(ApiUrlConstants.configurationApiUrl + 'countries')
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
  * Prepare left side menu navigation
   * @description
   * @date 2019-02-12
   * @param {MemberPrivilege[]} memberPrivileges
   * @param {boolean} isImpersonatedUser
   * @returns {MemberAllowedResources[]}
   * @memberof CommonService
   */
  prepareLeftMenuNavigation(memberPrivileges: MemberPrivilege[], isImpersonatedUser: boolean): MemberAllowedResources[] {
    if (memberPrivileges && memberPrivileges.length > 0) {
      const userInfo: Member = this._cacheService.get(CacheKey.UserInfo);
      const memberAllowedResources: MemberAllowedResources[] = [];
      MemberResourcesConstants.memberAllowedResources.forEach(x => {
        const memberPrivilege = memberPrivileges.find(item => item.id === x.id);
        const isHomeCountry = this.isHomeCountry(userInfo);
        if (memberPrivilege) {
          if (memberPrivilege.id === MemberAllowedResourcesLookup.DashBoard) {
            memberAllowedResources.push(this.constructMemberAllowedResource(x, memberPrivilege.resource));
          } else if (memberPrivilege.id === MemberAllowedResourcesLookup.ForeverBusinessOwnerSetup
            && userInfo && userInfo.memberTypeId === MemberType.PREFERREDCUSTOMER && isHomeCountry) {
            const hasUpgradeAsFBO = this._cacheService.get(CacheKey.HasUpgradeAsFBO);
            if (!hasUpgradeAsFBO) {
              memberAllowedResources.push(this.constructMemberAllowedResource(x, memberPrivilege.resource));
            }
          } else if (memberPrivilege.id === MemberAllowedResourcesLookup.Password) {
            memberAllowedResources.push(this.constructMemberAllowedResource(x, memberPrivilege.resource, isImpersonatedUser));
          } else {
            memberAllowedResources.push(this.constructMemberAllowedResource(x, memberPrivilege.resource));
          }
        }
      });
      return memberAllowedResources;
    }
  }

  /**
  * checks whether the selected country is home country
  * @returns {boolean}
  * @memberof CommonService
  */
  isHomeCountry(userInfo: Member): boolean {
    this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode).toUpperCase();
    if (userInfo && userInfo.homeCountryCode && this.isoCountryCode) {
      return userInfo.homeCountryCode.toUpperCase() === this.isoCountryCode.toUpperCase();
    }
    return false;
  }

  /**
   * Prepare Member allowed resources model
   * @param memberAllowedResource
   * @param resourceName
   * @param showLink
   */
  constructMemberAllowedResource(memberAllowedResource: MemberAllowedResources, resourceName: string,
    showLink?: boolean) {
    if (this._cacheService.get(CacheKey.CountryMetaData)) {
      this.updateCountryCodeinCookie();
    }
    const isoCountryCode: string = this._cacheService.getCookieValue(CacheKey.countryCode);
    const languageCode: string = this._cacheService.getCookieValue(CacheKey.languageCode);
    if (memberAllowedResource && isoCountryCode && languageCode) {
      const resource: MemberAllowedResources = {
        id: memberAllowedResource.id,
        resource: resourceName,
        resourceUrl: memberAllowedResource.resourceUrl ? environment.accountSiteURL + '/' +
          isoCountryCode.toLowerCase() + '/' + languageCode.toLowerCase()
          + memberAllowedResource.resourceUrl : '',
        icon: memberAllowedResource.icon,
        showLink: showLink
      };
      return resource;
    }
  }


  /**
  * Get Member allowed Countries based on MemberType
  * @param memberId
  */
  getMemberAllowedCountries(memberId: number): Observable<MemberAllowedCountries[]> {
    return this._http
      .get<MemberAllowedCountries[]>(
        ApiUrlConstants.accountApiUrl + '/members/' + memberId + '/allowed-countries?mappedEligibilities=true')
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
   * @description to get member information based on memberID
   * @param {number} memberId
   * @returns {Observable<Member>}
   * @memberof CommonService
   */
  getMemberDetails(distributorId: string): Observable<Member> {
    return this._http
      .get<Member>(ApiUrlConstants.accountApiUrl + '/member-details?distributorId=' + distributorId)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
   *
   *@description to get Specific member information based on memberID
   * @param {string} distributorId
   * @param {string} params
   * @returns {Observable<Member>}
   * @memberof CommonService
   */
  getMemberSpecificDetails(distributorId: string, params: string): Observable<Member> {
    return this._http
      .get<Member>(ApiUrlConstants.accountApiUrl + '/member-specific-details?distributorId=' + distributorId + '&options=' + params)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
   * Encode image url
   * @param {string} url
   * @returns {string}
   * @memberof CommonService
   */
  encodeImageURL(url: string): string {
    if (url) {
      return url.replace(/ /g, '%20');
    }
    return url;
  }

  /**
   * Sponsor Search
   * @param  {any} sponsorSearchRequest
   * @param  {number} limit?
   * @returns Observable
   */
  searchSponsors(sponsorSearchRequest: SponsorSearchRequest, limit?: number)
    : Observable<SponsorSearchResponse> {
    const _searchSponsorUrl = ApiUrlConstants.accountApiUrl +
      '/sponsor-search';
    return this._http
      .post<SponsorSearchResponse>(_searchSponsorUrl, sponsorSearchRequest)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
  * @description this method will  get sponsor by uuid
  * @date 2019-03-18
  * @returns {Observable<SponsorInformation>}
  * @memberof SponsorService
  */
  getSearchSponsorsByUUID(sponsorSearchResponse: SponsorSearchResponse): Observable<SponsorSearchResponse> {
    const _searchSponsorUrl = sponsorSearchResponse.location;
    return this._http
      .get<SponsorSearchResponse>(decodeURIComponent(encodeURIComponent(_searchSponsorUrl)))
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
   * @description get Map locations
   * @date 2019-11-11
   * @returns {Observable<MapLocationInfo[]>}
   * @memberof
   */
  getMapLocations(): Observable<MapLocationInfo[]> {
    const getURL = environment.cdnURL + '/locations/maplocations.json';
    return this._http
      .get<MapLocationInfo[]>(getURL)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
   * 
   */
  checkSkipNavigation(countryCode: string): boolean {
    let betaCountries = this.getBetaCountries();
    let skipNavigation = true;
    if (betaCountries !== undefined && betaCountries !== null && betaCountries.length > 0) {
      skipNavigation = !betaCountries.includes(countryCode.toLowerCase())
    }
    return skipNavigation;
  }

  /**
   * 
   * @param url 
   */
  navigateToInternalPreview(url) {
    let redirectHostName = new URL(url).hostname;
    redirectHostName = redirectHostName.replace('.com', '');
    if (redirectHostName && redirectHostName.includes('.')) {
      const redirectDomainParts = redirectHostName.split('.');
      const redirectSubDomain = redirectDomainParts[0];
      return this.isTitanSubDomain(redirectSubDomain, url);
    } else {
      if (url.toLowerCase().includes(environment.legacyURL)) {
        return false;
      } else if (this.checkAppRoute(url)) {
        return true;
      }
    }
    return false;
  }

  isTitanSubDomain(subDomain: string, url: string) {
    if (subDomain && environment.joinPortalSubDomainName &&
      subDomain.toLowerCase().includes(environment.joinPortalSubDomainName)) {
      return true;
    } else if (subDomain && environment.shopPortalSubDomainName &&
      subDomain.toLowerCase().includes(environment.shopPortalSubDomainName)) {
      return true;
    } else if (subDomain && environment.accountPortalSubDomainName &&
      subDomain.toLowerCase().includes(environment.accountPortalSubDomainName)) {
      return true;
    } else if ((subDomain && subDomain.toLowerCase().includes('corporate')) || subDomain.toLowerCase().includes('preview') ||
      (url.toLowerCase().includes(SharedConstants.PREVIEW_BASE_URL) && !url.toLowerCase().includes(environment.legacyURL))) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 
   * @param countryCode ISO Three Digit Country code
   */
  betaCountry(countryCode: string) {
    let betaCountries = this.getBetaCountries();
    let betaCountry = false;
    if (betaCountries !== undefined && betaCountries !== null && betaCountries.length > 0) {
      betaCountry = betaCountries.includes(countryCode.toLowerCase());
    }
    return betaCountry;
  }
  /**
   * @description Append Sponsor Id
   * @author njagadeesan
   * @date 2020-01-20
   * @param {string} route
   * @returns {string}
   * @memberof CommonService
   */
  appendFBOID(route: string, isLegacy?: boolean): string {
    const shareFBOID = this._cacheService.getSessionValue(CacheKey.fboId);
    if (shareFBOID && route) {
      const delimiter = route.indexOf('?') > -1 ? '&' : '?';
      let param = null;
      if (route.indexOf('#') > -1) {
        route = this.updateUrlParameter(route, isLegacy ? 'distribID' : 'fboId', shareFBOID);
      } else {
        param = isLegacy ? 'distribID=' : 'fboId=';
        route = route + delimiter + param + shareFBOID;
      }
      const memberSalePromotionModel = this._cacheService.getSessionValue(CacheKey.MemberSalePromotionModel);
      if (!isLegacy && memberSalePromotionModel) {
        const promotionModel = JSON.parse(memberSalePromotionModel);
        route = route + '&code=' + promotionModel.code + '&discountConfigType=' + promotionModel.discountConfigType;
      }
    }
    return route;
  }

  // Add / Update a key-value pair in the URL query parameters
  updateUrlParameter(uri: string, key: string, value: string): string {
    // remove the hash part before operating on the uri
    const i = uri.indexOf('#');
    const hash = i === -1 ? '' : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);
    // tslint:disable-next-line:quotemark
    const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
      uri = uri.replace(re, '$1' + key + '=' + value + '$2');
    } else {
      uri = uri + separator + key + '=' + value;
    }
    return uri + hash;
  }


  /**
   * @description To check Whether it is Internal portals
   * @author njagadeesan
   * @date 2020-01-20
   * @param {string} url
   * @returns {boolean}
   * @memberof CommonService
   */
  public checkAppRoute(url: string): boolean {
    if (url && url.indexOf(environment.cookieDomain.substr(1)) > -1) {
      return true;
    }
    return false;
  }
  /**
  * @description To Check Legacy Shop or Join
  * @author njagadeesan
  * @date 2020-02-05
  * @param {string} url
  * @returns {boolean}
  * @memberof CommonService
  */
  legacyShopOrJoin(url: string): boolean {
    if (url && url.toLowerCase().startsWith(environment.legacyJoinUrl.toLowerCase())
      || url.toLowerCase().startsWith(environment.legacyShopUrl.toLowerCase()) ||
      url.toLowerCase().startsWith(SharedConstants.LEGACY_JOIN_MOBILE_URL.toLowerCase())) {
      return true;
    }
    return false;
  }

  /**
 * Navigate to BETA portal
 * @param route 
 */
  constructBetaUrl(route: string): string {
    if (route !== undefined && route !== null && route !== '') {
      let url = new URL(route);
      let redirectHostName = this.findOutPortal(url.host, route);
      if (redirectHostName !== undefined && redirectHostName !== '') {
        let newRedirectUrl = redirectHostName + url.pathname + url.search;
        return newRedirectUrl;
      }
    }
    return route;
  }

  /**
   * Extract Portal
   */
  findOutPortal(url: string, routeUrl?: string) {
    if (environment.joinPortalSubDomainName && url.toLowerCase().includes(environment.joinPortalSubDomainName)) {
      return environment.enrollSiteURL;
    }
    else if (environment.shopPortalSubDomainName && url.toLowerCase().includes(environment.shopPortalSubDomainName)) {
      return environment.shopURL;
    }
    else if (environment.accountPortalSubDomainName && url.toLowerCase().includes(environment.accountPortalSubDomainName)) {
      return environment.accountSiteURL;
    }
    else if (environment.corporatePortalSubDomainName && url.toLowerCase().includes(environment.corporatePortalSubDomainName) || this.isTitanCorporate(routeUrl)) {
      return environment.corporateUrl;
    }
    else {
      return '';
    }
  }

  isTitanCorporate(route: string): boolean {
    let url = new URL(route);
    if (url && url.host
      && url.host.startsWith(environment.cookieDomain.substr(1))
      && route.indexOf(environment.legacyURL) === -1) {
      return true;
    }
    return false;
  }

  /**
   * This method used to get configured url
   * getConfigurationURL
   */
  getCountryConfigurationURL(country: Country, item: string): string {
    let url = '';
    switch (item) {
      case HamburgerItemConstants.SHOP:
        url = country.shopUrl;
        break;
      case HamburgerItemConstants.JOIN:
        url = country.enrollmentUrl;
        break;
      case HamburgerItemConstants.LOGIN:
        url = country.loginUrl;
        break;
      case HamburgerItemConstants.ABOUT:
        url = country.shopUrl;
        break;
      default:
        url = '';
        break;
    }
    return url;
  }

  /**
 * This method used to verify the flp360 access by fboid
 * verifyFlp360Access()
 */
  verifyFlp360Access(fboId: string): Observable<any> {
    const url = ApiUrlConstants.accountApiUrl + '/flp360/verify/' + fboId;
    return this._http.get<MapLocationInfo[]>(url)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
  * get member vat and discount info
  */
  getMemberVatAndDiscountInfo(userInfo: Member, taxCalculated?: boolean): MemberVatAndDiscountInfo {
    let memberVatAndDiscountInfo: MemberVatAndDiscountInfo;
    if (userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR) {
      memberVatAndDiscountInfo = {
        discountPercentage: this.getDiscountPerc(),
        vatRegistered: userInfo.vatRegistered ? true : false,
        taxCalculated: taxCalculated,
        memberTitleId: userInfo.memberTitleId,
        transactionalOptin: userInfo.transactionalOptin ? true : false,
        transactionalWholesaleQualified: userInfo.transactionalWholesaleQualified ? true : false,
        enableWHLSAL00ForAsstSupervisor: this.getEnableWHLSALForAsstSupervisor()
      };
    }
    return memberVatAndDiscountInfo;
  }
  /**
   * @description To Check stanalone page or not
   * @author njagadeesan
   * @date 2020-03-24
   * @param {string} url
   * @returns {string}
   * @memberof CommonService
   */
  isEventsPage(url: string): string {
    if (url) {
      const eventPage = SharedConstants.EVENT_PAGES.find((page: string) => {
        return url.toLowerCase().indexOf(page.toLowerCase()) > -1;
      });
      return eventPage;
    }
    return null;
  }

  /**
   * to get enable wholesale price flag for assistant supervisor
   * getEnableWHLSALEForAsstSupervisor()
   */
  getEnableWHLSALForAsstSupervisor(): boolean {
    const isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
    const enabledCountries = isoCountryCode && environment.enableWHLSAL00ForAsstSupervisor ?
      environment.enableWHLSAL00ForAsstSupervisor.split(',') : null;
    const country = enabledCountries && enabledCountries.length ? enabledCountries.find(item =>
      item.toLowerCase() === isoCountryCode.toLowerCase()) : null;
    return country ? false : true;
  }

  /**
   * prepareMemberDisplayConfigInfo()
   *
   * @returns Observable
   */
  prepareMemberDisplayConfigInfo(displayPage: number, taxInclusiveStore: boolean,
    userInfo: Member, taxCalculated: boolean, taxInclusiveShippingCountry: boolean): MemberDisplayConfigInfo {
    const shareFBOID = this._cacheService.getSessionValue(CacheKey.fboId) || null;
    const memberSalePromotionModel = this._cacheService.getSessionValue(CacheKey.MemberSalePromotionModel) || null;
    const memberDisplayConfigInfo: MemberDisplayConfigInfo = {
      userInfo: userInfo,
      taxInclusiveStore: taxInclusiveStore,
      displayPage: displayPage,
      taxCalculated: taxCalculated,
      taxInclusiveShippingCountry: taxInclusiveShippingCountry,
      shareFBOID: shareFBOID,
      memberSalePromotionModel: memberSalePromotionModel,
      enableWHLSAL00ForAsstSupervisor: this.getEnableWHLSALForAsstSupervisor()
    };
    return memberDisplayConfigInfo;
  }

  getMemberSalePromotionPriceTierId(): number {
    let priceTierId;
    const memberSalePromotionModel: MemberSalePromotionModel = JSON.parse(this._cacheService
      .getSessionValue(CacheKey.MemberSalePromotionModel));
    if (memberSalePromotionModel && memberSalePromotionModel.discountConfigType
      && memberSalePromotionModel.code) {
      priceTierId = memberSalePromotionModel.discountConfigType;
    }
    return priceTierId;
  }

  /**
  * To handle the obervable error response
  * @param  {Response|any} error
  */
  handleError(error: Response | any): TranslateParam {
    if (error && error.status >= 500) {
      const errorMsg = error.json();
      if (errorMsg) {
        return {
          errorGuid: errorMsg.errorId
        };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  getmappedcountries(countryCode: String) {
    const getMappedCountryUrl = ApiUrlConstants.configurationApiUrl + 'countries/' + countryCode + '/MappedCountries';
    return this._http
      .get(decodeURIComponent(encodeURIComponent(getMappedCountryUrl)))
      .pipe(catchError(this.handleErrorObservable));

  }

  updateCountryCodeinCookie() {
    let countryMetaData: CountryMetaData = JSON.parse(this._cacheService.get(CacheKey.CountryMetaData));
    if (countryMetaData && countryMetaData.countryID && countryMetaData.countryCode) {
      const storeCountry: string[] = countryMetaData.value.split(",");
      let storeIsoThreeCode;
      let countryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
      if (storeCountry && storeCountry.length > 0 && countryCode) {
        storeIsoThreeCode = storeCountry.find(x => x.toLowerCase() === countryCode.toLowerCase());
      }
      if (storeIsoThreeCode) {
        this._cacheService.setCookieValue(CacheKey.countryCode, countryMetaData.countryCode.toLowerCase());
        this._cacheService.setCookieValue(CacheKey.CountryId, countryMetaData.countryID);
        if (countryMetaData.countryLanguages) {
          let selectedLanguage = this._cacheService.getCookieValue(CacheKey.languageCode) ? countryMetaData.countryLanguages.find(x => x.languageCulture.toLowerCase() === this._cacheService.getCookieValue(CacheKey.languageCode).toLowerCase()) : null;
          if (!selectedLanguage) {
            const storeDefault: Language = countryMetaData.countryLanguages.find((x: any) => x.default === true) || countryMetaData.countryLanguages[0];
            const defaultLang: Language = countryMetaData.countryLanguages.find((x: any) =>
              x.languageCultureId === storeDefault.languageCultureId);
            this._cacheService.setCookieValue(CacheKey.languageCode, defaultLang.languageCulture);
          }
        }
      }
    }
  }


  /**
   * 
   * @param regionCode geting imagebt region
   */

}
